export function getBase64(file: File, cb: (s: string) => void) {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => {
    cb(reader.result as string);
  };
  reader.onerror = function (error) {
    console.error('Error: ', error);
  };
}